import React, { useEffect, useMemo,useState,} from "react";
import axios from "axios";
import {toast,ToastContainer, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./sms.css";

/* =========================================
   SMS COUNTER
========================================= */

function isGsm7(text = "") {
  const gsmChars =
    /^[A-Za-z0-9\s@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\[\~\]|€]*$/;

  return gsmChars.test(text);
}

function countSmsSegments(
  message = ""
) {
  const text = String(
    message || ""
  );

  const gsm =
    isGsm7(text);

  const length =
    text.length;

  if (gsm) {
    if (length <= 160) {
      return {
        encoding:
          "GSM-7",
        length,
        segments: 1,
      };
    }

    return {
      encoding:
        "GSM-7",
      length,
      segments:
        Math.ceil(
          length / 153
        ),
    };
  }

  if (length <= 70) {
    return {
      encoding:
        "UNICODE",
      length,
      segments: 1,
    };
  }

  return {
    encoding:
      "UNICODE",
    length,
    segments:
      Math.ceil(
        length / 67
      ),
  };
}

/* =========================================
   CONSTANTS
========================================= */

const DEFAULT_SENDER_IDS =
  [
    "ZAKA-PAY",
    "SADAKA-PAY",
    "AHADI",
    "MAVUNO",
    "PAROKIA",
    "UWAKA",
    "WAWATA"
    // "INFORM"
  ];

/* =========================================
   COMPONENT
========================================= */

export default function MassSMS() {

  const [sending, setSending] = useState(false);
  const [response, setResponse] = useState(null);
  const [smsBalance, setSmsBalance] = useState(0);
  const [form, setForm] =
    useState({
      senderId: "",
      phones: "",
      message: "",
      scheduleDate: "",
    });

  /* =========================================
     UPDATE FORM
  ========================================= */

  const updateForm = (
    key,
    value
  ) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /* =========================================
     RECIPIENTS
  ========================================= */

  const recipientPhones =
    useMemo(() => {

      return form.phones
        .split(",")
        .map((p) =>
          p.trim()
        )
        .filter(Boolean);

    }, [form.phones]);

  /* =========================================
     SMS ANALYSIS
  ========================================= */

  const smsInfo =
    useMemo(() => {

      return countSmsSegments(
        form.message
      );

    }, [form.message]);

  const totalEstimatedUsage =
    smsInfo.segments *
    recipientPhones.length;

    /* =========================================
        LOAD SMS BALANCE
        ========================================= */

        useEffect(() => {

        fetchBalance();

        }, []);

        const fetchBalance =
        async () => {

            try {

            const res =
                await axios.get(
                "/sms/balance"
                );

            const balance =
                Number(
                res?.data?.balance || 0
                );

            setSmsBalance(
                balance
            );

            } catch (err) {

            console.error(
                "Failed to fetch balance",
                err
            );
            }
        };
  /* =========================================
     SEND
  ========================================= */

  const handleSend =
    async () => {

      if (
        !form.senderId
      ) {
        toast.error(
          "Select Sender ID"
        );

        return;
      }

      if (
        !form.message.trim()
      ) {
        toast.error(
          "Enter SMS message"
        );

        return;
      }

      if (
        recipientPhones.length ===
        0
      ) {
        toast.error(
          "Enter recipients"
        );

        return;
      }

      try {

        setSending(true);

        const payload = {

          senderId:
            form.senderId,

          message:
            form.message,

          scheduleDate:
            form.scheduleDate ||
            null,

          phones:
            recipientPhones,
        };

        const res = await axios.post(
            "/sms/send-mass",
            payload
            );

        setResponse(
          res.data
        );

        toast.success(
          "Mass SMS sent successfully"
        );

      } catch (err) {

        console.error(err);

        toast.error(
          err?.response?.data?.message ||
          "Failed to send SMS"
        );

      } finally {

        setSending(false);
      }
    };

  /* =========================================
     UI
  ========================================= */

  return (
    <div className="sms-page">

      {/* HEADER */}

      <div className="sms-card">

      <div className="sms-header-row">

        <div>

          <h2>
            Mass SMS
          </h2>

          <p>
            Send one message
            to many recipients
          </p>

        </div>

        <div className="sms-dashboard">

          <div className="sms-stat-card">

            <span>
              SMS Balance
            </span>

            <strong>
              {smsBalance.toLocaleString()}
            </strong>

          </div>

          <div className="sms-stat-card">

            <span>
              Recipients
            </span>

            <strong>
              {recipientPhones.length}
            </strong>

          </div>

          <div className="sms-stat-card">

            <span>
              Usage
            </span>

            <strong>
              {totalEstimatedUsage}
            </strong>

          </div>

          {/* <div className="sms-stat-card">

            <span>
              Encoding
            </span>

            <strong>
              {smsInfo.encoding}
            </strong>

          </div> */}

        </div>

      </div>

    </div>

      {/* COMPOSE */}

      <div className="sms-card">

        <div className="sms-grid">

          <div>

            <label>
              Sender ID
            </label>

            <select
              className="sms-input"
              value={
                form.senderId
              }
              onChange={(
                e
              ) =>
                updateForm(
                  "senderId",
                  e.target.value
                )
              }
            >
              <option value="">
                Select Sender ID
              </option>

              {DEFAULT_SENDER_IDS.map(
                (id) => (
                  <option
                    key={id}
                    value={id}
                  >
                    {id}
                  </option>
                )
              )}

            </select>

          </div>

          <div>

            <label>
              Schedule
            </label>

            <input
              type="datetime-local"
              className="sms-input"
              value={
                form.scheduleDate
              }
              onChange={(
                e
              ) =>
                updateForm(
                  "scheduleDate",
                  e.target.value
                )
              }
            />

          </div>

        </div>

        <div
          style={{
            marginTop: 20,
          }}
        >

          <label>
            Phone Numbers
          </label>

          <textarea
            className="sms-textarea"
            rows={5}
            placeholder="255712345678,255754321000"
            value={
              form.phones
            }
            onChange={(
              e
            ) =>
              updateForm(
                "phones",
                e.target.value
              )
            }
          />

          <div className="sms-helper">
            Separate phone numbers
            using commas
          </div>

        </div>

        <div
          style={{
            marginTop: 20,
          }}
        >

          <label>
            Message
          </label>

          <textarea
            className="sms-textarea"
            rows={6}
            placeholder="Enter message..."
            value={
              form.message
            }
            onChange={(
              e
            ) =>
              updateForm(
                "message",
                e.target.value
              )
            }
          />

        </div>

        {/* SMS ANALYTICS */}

        <div className="sms-analysis">

          <div>
            Characters:
            <strong>
              {" "}
              {
                smsInfo.length
              }
            </strong>
          </div>

          <div>
            Encoding:
            <strong>
              {" "}
              {
                smsInfo.encoding
              }
            </strong>
          </div>

          <div>
            SMS Units:
            <strong>
              {" "}
              {
                smsInfo.segments
              }
            </strong>
          </div>

          <div>
            Recipients:
            <strong>
              {" "}
              {
                recipientPhones.length
              }
            </strong>
          </div>

          <div>
            Estimated Usage:
            <strong>
              {" "}
              {
                totalEstimatedUsage
              }
            </strong>
          </div>

        </div>
              {totalEstimatedUsage >
                smsBalance && (

                <div className="sms-warning">

                    SMS balance may not be enough.

                </div>
                )}
        {smsInfo.segments >
          1 && (

          <div className="sms-warning">

            This message exceeds
            160 characters and
            will consume{" "}

            {
              smsInfo.segments
            }

            {" "}SMS units
            per recipient.

          </div>
        )}

       <div className="sms-row no-border">
        <div />

          <button
            className="sms-action-btn"
            disabled={sending }
            onClick={handleSend }
          >
            {sending
              ? "Sending..."
              : "Send Mass SMS"}
          </button>

        </div>

      </div>

      {/* RESPONSE */}

      {response && (

        <div className="sms-card">

          <div className="sms-preview-title">
            Provider Response
          </div>

          <pre
            style={{
              whiteSpace:
                "pre-wrap",
            }}
          >
            {
              // JSON.stringify(
              //   response,
              //   null,
              //   2
              // )
            }
          </pre>

        </div>
      )}

      <ToastContainer />

    </div>
  );
}